<p>
  <span *ngIf="displayDate">{{displayDate|date:format}} <span *ngIf="item.show_timezone">*{{timezone}}</span></span>
  <br /><span *ngIf="momentDate && !is_local && item.display_local">{{'local_time'| translation}}: {{momentDate|date:format}}<span></span></span>
</p>
